<script setup lang="ts">
import { useJitsiStore } from "@/stores/jitsiStore";
import FloatingWindow from "@/components/integrations/jitsi/FloatingWindow.vue";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";

const store = useJitsiStore();
// @ts-ignore
const { prepareId, meetingDiv } = storeToRefs(store);
const { joinRoom } = store;

onMounted(() => {
  if (prepareId.value) {
    joinRoom(prepareId.value);
  }
});
</script>

<template>
  <FloatingWindow
    :initial-width="750"
    :initial-height="450"
    :initial-x="200"
    :initial-y="100"
    title="Call"
  >
    <div
      ref="meetingDiv"
      class="tw:w-full tw:h-full"
    ></div>
  </FloatingWindow>
</template>
